import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { MultiSelectInput } from '@sabre/aven-spark';

const noOp = () => {};

class LanguageSelectBase extends Component {
    static propTypes = {
        onChange: PropTypes.func
    };

    componentDidMount() {
        this.languageSelect = new MultiSelectInput(this.languageSelectRef, {
            onChange: this.props.onChange || noOp
        });
    }
    componentWillUnmount() {
        this.languageSelect && this.languageSelect.remove();
    }
    render() {
        return (
            <label
                className="spark-multi-select spark-multi-select--no-title"
                ref={node => (this.languageSelectRef = node)}
            >
                <select className="spark-multi-select__input" multiple size="5">
                    {this.props.languageList.map(language => (
                        <option value={language.code} key={language.code}>
                            {language.name}
                        </option>
                    ))}
                </select>
            </label>
        );
    }
}

const mapStateToProps = state => {
    return {
        languageList: state.app.selected.languageList,
        defaultLanguageCode: state.app.selected.defaultCode
    };
};

const LanguageSelect = connect(mapStateToProps)(LanguageSelectBase);
export { LanguageSelect };



// WEBPACK FOOTER //
// ./src/components/pages/pages/search/labels/language-select.js